module.exports = {
  init: () => {
    $(".imagefilter").click(function() {
      $(this).toggleClass("imagefilter--active");
      return false;
    });
  }
};
